export enum CategoryEnum {
    RealEstate = "Real Estate",
}

export const NO_CATEGORY_ID = "no-category";